import {styled} from '@mui/material';

const Container = styled('div')`
	border: 1px solid ${({theme}) => theme.palette.grey[300]};
	border-radius: 16px;
	height: 100%;
	min-width: 328px;
	display: flex;
	flex-direction: column;
	background-color: #fff;

	@media (max-width: 320px) {
		min-width: 285px;
	}
`;

const CardHeader = styled('div')`
	background-color: #eef6ff;
	padding: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 16px 16px 0 0;
	gap: 8px;
`;

const CardContent = styled('div')`
	padding: 8px 24px 0px;
	gap: 12px;
	display: flex;
	flex-direction: column;
	height: 100%;

	svg {
		color: #535862;
	}
`;

const CardFooter = styled('div')`
	padding: 14px 24px;
	display: flex;
	justify-content: flex-end;
	width: 100%;
`;

const Dot = styled('span')`
	background-color: ${({theme}) => theme.palette.primary.main};
	width: 4px;
	height: 4px;
	border-radius: 50%;
`;

const Tag = styled('span')`
	color: #122368 !important;
	background-color: #d1e0ff;
	width: fit-content;
	padding: 2px 8px;
	border-radius: 999px;
	font-size: 0.75rem;
	font-weight: 600;
`;

export {Container, CardHeader, CardContent, CardFooter, Dot, Tag};
